<template>
  <router-view :key="key"></router-view>
</template>

<script>
export default {
  name: 'nested',
  computed: {
    key() {
      return this.$route.name !== undefined? this.$route.name +new Date(): this.$route +new Date()
    }
  },
}
</script>

<!--
<style scoped>
/deep/ .el-table__header-wrapper {
  display: none;
}
/deep/ .is-guttered  {
  min-height: 800px;
}
</style>
-->
